export default "__VITE_ASSET__44a325a4__"